import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { EuiFlexGrid } from "@elastic/eui";
import styled from "styled-components";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TripSection from "../../shared/TripSection";
import SupplierDetails from "./SupplierDetails";
import DriverDetails from "./DriverDetails";
import TruckDetails from "./TruckDetails";
import TruckTypeDetails from "./TruckTypeDetails";
import SupplierContractType from "./SupplierContractType";
import ModalComponent from "../../../../../components/modal";
import { useSelector } from "react-redux";
import { getUserRoles } from "modules/auth/slice";


export const NotesStyle = styled.div`
    margin: 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    background: #fffbeb;
    border-radius: 6px;
    color: #92400e;
    justify-content: space-between;
    p {
        display: flex;
        align-items: center;
        svg {
            color: #fbbf24;
            margin: 5px;
        }
    }
    span {
        font-weight: bold;
        margin: 0 3px;
    }
    button {
        color: #b45309;
        display: flex;
        align-items: center;
        svg {
            margin: 0 3px;
        }
    }
`;

export default function DrivingDetails({
    supplierOptions,
    supplierName,
    isSupplierConfirmed,
    isSupplierEditable,
    onSupplierChange,
    supplierContractTypeName,
    supplierContractTypeOptions,
    isSupplierContractTypeEditable,
    onSupplierContractTypeChange,
    driverOptions,
    driverName,
    isDriverConfirmed,
    isDriverEditable,
    onDriverChange,
    truckOptions,
    truckPlateNumber,
    isTruckConfirmed,
    isTruckEditable,
    onTruckChange,
    truckType,
    onConfirmingField,
    supplierId,
    clientNotes,
    orderId,
    organizationId
}) {
    const intl = useIntl();
    const supplierLabel = intl.formatMessage({ id: "trip.supplier" });
    const supplierContractTypeLabel = intl.formatMessage({ id: "trip.supplier-contract-type" });
    const driverLabel = intl.formatMessage({ id: "trip.driver" });
    const truckLabel = intl.formatMessage({ id: "trip.truck" });
    const truckTypeLabel = intl.formatMessage({ id: "trip.truck-type" });
    const [showNote, setShowNote] = useState(false);

    const getCurrentUserRoles = useSelector(getUserRoles());
    const isUserSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager")
    return (
        <>
            {clientNotes !== "" && clientNotes !== null && orderId !== null && (
                <NotesStyle>
                    <p>
                        <InfoIcon />
                        Find <span> Client Notes </span> on the order <span>#{orderId}</span>{" "}
                    </p>
                    <button onClick={() => setShowNote(true)}>
                        View Notes <ArrowForwardIcon />
                    </button>
                </NotesStyle>
            )}
            <TripSection
                headerTitle={<FormattedMessage id="trip.supplier-details-section-title" />}
                headerIconType="user"
            >
                <EuiFlexGrid
                    columns={3}
                    gutterSize="l"
                >
                    <SupplierDetails
                        label={supplierLabel}
                        supplierOptions={isUserSupplierPartner ? { ...supplierOptions, filterResource: `filter[organization_id]=${organizationId}` } : supplierOptions}
                        supplierName={supplierName}
                        onChange={onSupplierChange}
                        isEditable={isSupplierEditable}
                        onConfirmingField={onConfirmingField}
                        isConfirmed={isSupplierConfirmed}
                    />
                    <SupplierContractType
                        label={supplierContractTypeLabel}
                        supplierContractTypeOptions={supplierContractTypeOptions}
                        supplierContractTypeName={isUserSupplierPartner ? supplierContractTypeName || "monthly" : supplierContractTypeName}
                        onChange={onSupplierContractTypeChange}
                        isEditable={isSupplierContractTypeEditable}
                    />
                    <DriverDetails
                        label={driverLabel}
                        driverOptions={driverOptions}
                        driverName={driverName}
                        supplierId={supplierId}
                        onChange={onDriverChange}
                        isEditable={isDriverEditable}
                        onConfirmingField={onConfirmingField}
                        isConfirmed={isDriverConfirmed}
                    />
                    <TruckDetails
                        label={truckLabel}
                        truckOptions={truckOptions}
                        plateNumber={truckPlateNumber}
                        supplierId={supplierId}
                        onChange={onTruckChange}
                        isEditable={isTruckEditable}
                        isConfirmed={isTruckConfirmed}
                        onConfirmingField={onConfirmingField}
                    />
                    <TruckTypeDetails
                        label={truckTypeLabel}
                        type={truckType && truckType.alias}
                        isEditable={!isUserSupplierPartner}
                    />
                </EuiFlexGrid>
            </TripSection>
            <ModalComponent
                onClose={() => setShowNote(false)}
                open={showNote}
                header="Client Notes :"
            >
                {clientNotes}
            </ModalComponent>
        </>
    );
}
